module.exports = __webpack_public_path__ + "img/tabicon_6.185d9916.png";